import defineRule from '../defineRule';
import { isValidPassword } from 'src/utils/validators';
defineRule('validPassword', (password) => {
    return isValidPassword(`${password}`);
});
